// extracted by mini-css-extract-plugin
export default {"headTabs":"HeaderTabStyle_headTabs__2iV0T","tabNames":"HeaderTabStyle_tabNames__O5a84","tabValues":"HeaderTabStyle_tabValues__tPJOu"};